import { Services, getShortUrl } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import { presetOrDomain } from '@/components/services/url-shortener/utils'

import render from './render'

export default {
  name: 'Item',

  mixins: [ presetOrDomain ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    hasOwner() {
      return !!(this.value.owner || this.value.ownerId)
    },
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },

    shortUrl() {
      return getShortUrl(this.value)
    },

    $_generationParams() {
      return this.value?.meta?.generationParams
    }
  },

  render
}
